<template>
  <b-field>
    <template #label horizontal>
     {{$t('Fault tolerance for fuzzy search')}}
      <b-tooltip :label="$t('Also provides results that do not exactly match the search terms, such as misspellings')" multilined style="vertical-align: bottom">
	<b-icon icon="question-circle"/>
      </b-tooltip>
    </template>
    <b-field>
      <b-radio-button
	v-for="(level, index) in levels"
	:key="index"
	@input="$emit('input', level)"
	:value="value"
	:native-value="level"
	expanded
      >
	{{ labelsByLevel[level] }}
      </b-radio-button>
    </b-field>
  </b-field>
</template>

<script>
 export default {
   props: {
     value: {
       type: Number,
       default: 0
     }
   },
   data() {
     return {
       levels: [0, 1, 3],
       labelsByLevel: {
	 0: this.$t('Without'),
	 1: this.$t('Medium'),
	 3: this.$t('High')
       }
     }
   }
 }
</script>
